import { useRoutes } from "react-router-dom";
import LandingPage from "../pages/landing";
import OrderPage from "../pages/order";
import StatusPage from "../pages/status";
import AuthorizePage from "../pages/authorize";

export default function AppRoutes() {
  return useRoutes([
    {
      path: "/",
      element: <LandingPage />,
    },

    {
      path: "/order",
      element: <OrderPage />,
    },

    {
      path: "/shipping-status",
      element: <StatusPage />,
    },

    {
      path: "/authorize",
      element: <AuthorizePage />,
    },
  ]);
}
